var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDetail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 10,
  viewBox: "0 0 12 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H12V1H0V0Z",
  fill: "#FADAAA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 3H12V4H2V3Z",
  fill: "#FADAAA"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6H4V7H12V6Z",
  fill: "#FADAAA"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 9H12V10H6V9Z",
  fill: "#FADAAA"
})));
export { SvgDetail as ReactComponent };
export default __webpack_public_path__ + "assets/icons/detail.ff2eba.svg";